import React from 'react';
import './WalletModal.css';

function WalletModal({ show, onClose, connectWallet }) {
  if (!show) {
    return null;
  }

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h2>CONNECT WALLET</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>
        <ul className="wallet-list">
          <li onClick={connectWallet}>
            <img
              src="https://logowik.com/content/uploads/images/metamask4112.jpg"
              alt="MetaMask"
              className="wallet-logo"
            />
          </li>
        </ul>
        <p className="terms">
          By using CodeXchange, you agree to our <a href="/terms">Terms of Service</a> and our <a href="/privacy">Privacy Policy</a>.
        </p>
      </div>
    </div>
  );
}

export default WalletModal;